import React from 'react';
import classNames from 'classnames';

const RegisterIcon = ({ propsClassName, iconImage, ariaLabelText, noRole }) => {
  return (
    <picture>
      <source
        media="(max-width: 799px)"
        srcSet={iconImage}
        width="48"
        height="40"
      />
      <source
        media="(min-width: 800px)"
        srcSet={iconImage}
        width="80"
        height="40"
      />
      <img
        className={classNames({
          'registration-icon': true,
          [propsClassName]: propsClassName,
        })}
        src={iconImage}
        alt="registration-icon"
        tabIndex={0}
        role={noRole ? null : 'button'}
        aria-label={ariaLabelText}
        width="80"
        height="40"
      />
    </picture>
    // <img
    // className={classNames({
    //   'registration-icon': true,
    //   [propsClassName]: propsClassName,
    // })}
    // src={iconImage}
    // alt="registration-icon"
    // tabIndex={0}
    // role={noRole ? null : 'button'}
    // aria-label={ariaLabelText}
    // />
  );
};

export default RegisterIcon;
